import React from 'react';
import HeroImage from '../../../common/hero-image';
import { HEADER_FONTS } from '../../../common/description-component';
import TitleAndDescription from '../../../common/title-and-description';
import SpacerVertical from '../../../common/spacer-vertical';

const LiveBlogIntro = () => {
  return (
    <>
      <SpacerVertical size="40px" />
      <TitleAndDescription
        titleFont={HEADER_FONTS.Large}
        title="Live Blog"
        description={
          <>
            Deliver the news as it happens. Live blog is one of the best ways to deliver information
            quickly and in context, and keep your readers engaged. You can keep each event live for
            one day or even a year – whatever is relevant to the story. You also can assign specific
            reporters to an event, and only they will be able to update it.
          </>
        }
      />

      <SpacerVertical size="20px" />

      <HeroImage
        src="https://publisher-assets.spot.im/host-panel/live-blog-2.png"
        alt="Article Reactions preview"
      />
    </>
  );
};

export default LiveBlogIntro;
